import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Models
import mCarpark from 'models/cpm/carpark';
// HOCs
import withStateReinit from 'hocs/WithStateReinit';
// Custom
import { cpmGetCarparksAutoComplete, updateListLastParams } from 'actions';
import { cpmCarparkDataShape, fullListShape } from 'constants/PropTypesShapes';
import AutoCompleteSearchFieldFilter from 'components/filters/AutoCompleteSearchFieldFilter';
import { CarparkItem } from 'components/items/InformationItems';

const CarparkAutoCompleteItem = ({ element, onSelect }) => {
  if (element) {
    const carpark = { ...element };

    return (
      <div className="information-item-wrapper">
        <CarparkItem label={carpark.name} value={carpark.name} onClick={() => onSelect(carpark)} />
      </div>
    );
  }
  return null;
};

CarparkAutoCompleteItem.propTypes = {
  element: cpmCarparkDataShape,
  onSelect: PropTypes.func,
};

CarparkAutoCompleteItem.defaultProps = {
  element: null,
  onSelect: null,
};

class CarparkAutoCompleteFilter extends React.Component {
  constructor(props) {
    super(props);

    this.handleGetElements = this.handleGetElements.bind(this);
    this.handleSelectElement = this.handleSelectElement.bind(this);
  }

  componentWillUnmount() {
    const { handleResetListLastParams } = this.props;

    handleResetListLastParams();
  }

  // Handlers
  handleGetElements(value, page) {
    const { listCarparks } = this.props;

    // Get default carparks list features
    const { defaultParams: { pagination, sort }, autoCompleteFilter } = mCarpark.listFeatures;

    // Define the page to be loaded
    const finalPagination = {
      page: page || pagination.page,
      pageSize: pagination.pageSize,
    };

    // Load carparks
    const filter = { ...autoCompleteFilter, value };
    listCarparks(finalPagination, sort, [filter]);
  }

  handleSelectElement(carpark) {
    const { onSelect } = this.props;

    onSelect(carpark);
  }

  render() {
    const { carpark, carparks: { loading, elements: { data: elements, pageNumber, totalPages } } } = this.props;

    return (
      <AutoCompleteSearchFieldFilter
        label="field.carpark"
        element={carpark}
        loading={loading}
        elements={elements || []}
        pagination={{ pageNumber, totalPages }}
        elementComp={<CarparkAutoCompleteItem />}
        onGetElements={this.handleGetElements}
        elementDescBuilder={(c) => (c.name)}
        onSelectElement={this.handleSelectElement}
      />
    );
  }
}

CarparkAutoCompleteFilter.propTypes = {
  carpark: cpmCarparkDataShape,
  carparks: fullListShape.isRequired,
  handleResetListLastParams: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  listCarparks: PropTypes.func.isRequired,
};

CarparkAutoCompleteFilter.defaultProps = {
  carpark: null,
};

const mapStateToProps = (state) => ({
  carparks: state.cpmAutoComplete.carparks,
});

const mapDispatchToProps = (dispatch) => ({
  handleResetListLastParams: () => {
    dispatch(updateListLastParams(mCarpark.name, true));
  },
  listCarparks: (pagination, sort, filters) => {
    dispatch(
      cpmGetCarparksAutoComplete(
        mCarpark.queListCarparksForAutoComplete,
        { },
        { pagination, sort, filters },
      ),
    );
  },
});

module.exports = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateReinit(['autoCompleteCarparks']),
)(CarparkAutoCompleteFilter);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkAutoCompleteFilter.js